module.exports = __webpack_public_path__ + "img/energizer.0203537b.png";